import { Input } from "@ui/components/input";
import { Label } from "@ui/components/label";
import React, { useState } from "react";
import { useRange, UseRangeProps } from "react-instantsearch";

interface CustomRangeInputProps extends UseRangeProps {
  mask?: (value: string) => string;
  filterLabel: string;
}

export function CustomRangeInput(props: CustomRangeInputProps) {
  const { start, range, canRefine, refine } = useRange(props);
  const step = 1 / Math.pow(10, 0);

  const values = {
    min: start[0] !== -Infinity && start[0] !== range.min ? start[0] : "",
    max: start[1] !== Infinity && start[1] !== range.max ? start[1] : "",
  };

  const [prevValues, setPrevValues] = useState(values);
  const [{ from, to }, setRange] = useState({
    from: values.min?.toString(),
    to: values.max?.toString(),
  });

  if (values.min !== prevValues.min || values.max !== prevValues.max) {
    setRange({ from: values.min?.toString(), to: values.max?.toString() });
    setPrevValues(values);
  }

  const handleRefine = () => {
    refine([
      from ? Number(from.replace(/\./g, "").replace(",", ".")) : undefined,
      to ? Number(to.replace(/\./g, "").replace(",", ".")) : undefined,
    ]);
  };

  const applyMask = (value: string): string =>
    props.mask ? props.mask(value) : value;

  return (
    <div className="flex flex-col mt-4">
      <h3 className="text-xl font-semibold mb-2">{props.filterLabel}</h3>
      <form onSubmit={(event) => event.preventDefault()}>
        <div className="flex gap-2 dark:text-black">
          <div className="border-[1px] rounded-[5px] bg-white relative pt-4">
            <Label
              htmlFor={`min`}
              className="pl-3 absolute top-2 text-gray-400"
            >
              De
            </Label>
            <Input
              id={`min`}
              type="text"
              min={range.min}
              max={range.max}
              value={applyMask(from || "")}
              step={step}
              placeholder={applyMask(range.min?.toString() ?? "")}
              disabled={!canRefine}
              onInput={({ currentTarget }) => {
                const value = currentTarget.value.replace(/\D/g, "");
                setRange({ from: value || "", to });
              }}
              onBlur={handleRefine}
              className="border-none bg-transparent pb-0 focus:!ring-0"
            />
          </div>
          <div className="border-[1px] rounded-[5px] bg-white relative pt-4">
            <Label
              htmlFor={`max`}
              className="pl-3 absolute top-2 text-gray-400"
            >
              Até
            </Label>
            <Input
              id={`max`}
              type="text"
              min={range.min}
              max={range.max}
              value={applyMask(to || "")}
              step={step}
              placeholder={applyMask(range.max?.toString() ?? "")}
              disabled={!canRefine}
              onInput={({ currentTarget }) => {
                const value = currentTarget.value.replace(/\D/g, "");
                setRange({ from, to: value || "" });
              }}
              onBlur={handleRefine}
              className="border-none bg-transparent pb-0 focus:!ring-0"
            />
          </div>
        </div>
      </form>
    </div>
  );
}
